import { ApplicationConfig } from '@angular/core';
import { provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { provideNzIcons } from 'ng-zorro-antd/icon';
import { DownloadOutline, PlusOutline, SearchOutline } from '@ant-design/icons-angular/icons';
import { appRoutes } from './app.routes';
import { coreConfig } from './core/core.config';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(appRoutes, withPreloading(PreloadAllModules)),
    provideNzIcons([DownloadOutline, PlusOutline, SearchOutline]),
    ...coreConfig.providers,
  ]
};
